import { cn } from "~/lib/utils";
import { Toggle } from "~/components/Toggle";

// // // //

/**
 * ToggleRow
 * A boolean control laid out as a row: label (with optional description)
 * on the left and a switch on the right.
 */
export function ToggleRow(props: {
    label: string;
    description?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (updatedValue: boolean) => void;
}) {
    const { label, description, checked, disabled = false, onChange } = props;

    return (
        <div
            className={cn("flex items-center justify-between gap-3", {
                "opacity-50": disabled,
            })}
        >
            <span className="flex flex-col">
                <span className="text-sm text-foreground select-none">
                    {label}
                </span>
                {description && (
                    <span className="text-xs text-muted-foreground select-none">
                        {description}
                    </span>
                )}
            </span>

            <Toggle
                checked={checked}
                size="md"
                color="blue"
                onChange={(updatedValue) => {
                    if (disabled) return;
                    onChange(updatedValue);
                }}
            />
        </div>
    );
}
